module.exports = require('./dist/shared/lib/constants')
